import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

// Opname operations
const getOpnameList = async (params: any) => {
  const url = endpoints.OPNAME;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const getOpnameAll = async () => {
  const url = endpoints.OPNAME_ALL;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const getOpnameDetail = async (id: number) => {
  const url = endpoints.OPNAME_DETAIL(id);

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createOpname = async (payload: any) => {
  const url = endpoints.OPNAME;

  const { data: response } = await axios.post(url, payload, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateOpname = async (id: number, payload: any) => {
  const url = endpoints.OPNAME_DETAIL(id);

  const { data: response } = await axios.patch(url, payload, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteOpname = async (id: number) => {
  const url = endpoints.OPNAME_DETAIL(id);

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const downloadOpnameBulkTemplate = async () => {
  const url = endpoints.OPNAME_BULK_TEMPLATE;

  const response = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    responseType: "blob",
  });

  return response;
};

const uploadOpnameBulk = async (formData: FormData) => {
  const url = endpoints.OPNAME_BULK;

  const { data: response } = await axios.post(url, formData, {
    headers: {
      Authorization: accessToken,
      "Content-Type": "multipart/form-data",
    },
  });

  return response;
};

// Stock Opname operations
const getStockOpnameList = async (params: any) => {
  const url = endpoints.OPNAME_STOCK;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const getStockOpnameDetail = async (id: number) => {
  const url = endpoints.OPNAME_STOCK_DETAIL(id);

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createStockOpname = async (payload: any) => {
  const url = endpoints.OPNAME_STOCK;

  const { data: response } = await axios.post(url, payload, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateStockOpname = async (id: number, payload: any) => {
  const url = endpoints.OPNAME_STOCK_DETAIL(id);

  const { data: response } = await axios.patch(url, payload, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteStockOpname = async (id: number) => {
  const url = endpoints.OPNAME_STOCK_DETAIL(id);

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const opname = {
  // Opname
  getOpnameList,
  getOpnameAll,
  getOpnameDetail,
  createOpname,
  updateOpname,
  deleteOpname,
  downloadOpnameBulkTemplate,
  uploadOpnameBulk,
  // Stock Opname
  getStockOpnameList,
  getStockOpnameDetail,
  createStockOpname,
  updateStockOpname,
  deleteStockOpname,
};

export default opname;
